module.exports = __webpack_public_path__ + "ch.svg?4abf347744438a7021ebebbcc7da720e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ch.svg
// module id = 1025
// module chunks = 27